<template>
  <div>
    <b-row>
      <b-col>
        <label class="mb-2">
          <i class="fa fa-fa fa-link text-muted"></i>
          {{ trans('attach_a_url') }}
          <small class="text-muted">
            <i class="fa fa-fw fa-info-circle" id="short_url"></i>
          </small>
          <b-tooltip target="short_url" triggers="hover">
            {{ trans('attach_a_url_details') }}
          </b-tooltip>
        </label>
      </b-col>
      <b-col class="col-auto text-right">
        <a href="#" class="text-danger" @click.prevent="$emit('cancel')">
          <i class="fa fa-fw fa-times"></i>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input v-model="url" placeholder="https://yourpage.com" />
        <small v-if="!isUrlValid" class="form-text text-danger text-right">
          {{ trans('invalid_url') }}
        </small>
      </b-col>
      <b-col class="col-auto pl-0">
        <b-button variant="primary" v-b-modal.insert-document-link-modal>
          {{ trans('document') }} / {{ trans('page').toLowerCase() }}
        </b-button>
      </b-col>
    </b-row>
    <insert-document-link-modal
      :organization="organization"
      :initial_url="url"
      v-model="url"
      @document="$emit('document', $event)"
      @page="$emit('page', $event)"
    ></insert-document-link-modal>
  </div>
</template>

<script>
  import InsertDocumentLinkModal from './InsertDocumentLinkModal'

  export default {
    props: {
      organization: Object,
      value: String,
      nullable: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      InsertDocumentLinkModal,
    },
    data() {
      return {
        trans: trans,
        url: this.value,
      }
    },
    watch: {
      url() {
        this.$emit('input', this.url)
      },
    },
    computed: {
      isUrlValid() {
        return _.validateUrl((this.url||'').trim())
      },
    },
    mounted() {
      window.sendOutUrlComponent = this
    },
  }
</script>